import { Box } from '@mui/material';
import React, { ReactNode } from 'react';
import CustomTypography from './CustomTypography';
import IconWarn from '../../assets/icons/IconWarn';

type WarnMessageProps = {
  children: ReactNode;
};

const WarnMessage = ({ children }: WarnMessageProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        // flex: '1',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <IconWarn />
      <CustomTypography
        variant='body1'
        sx={{
          color: '#FFC107',
          fontFamily: 'Montserrat',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '18px',
          flex: '1',
        }}
      >
        {children}
      </CustomTypography>
    </Box>
  );
};

export default WarnMessage;
